import { memo } from 'react'

import s from './ErrorMessage.module.scss'

import { useAppErrorContext } from 'contexts/AppErrorContext'

import { ExclamationIcon } from 'assets/icons/ExclamationIcon'

import { CModal } from 'components/UI/Modal/CModal'

const ErrorMessage = memo((props: { message: string }) => {
  const { message } = props

  const { setAppError } = useAppErrorContext()

  const closeButtonHandler = () => {
    setAppError('')
  }

  return (
    <CModal variant="secondary" onHide={closeButtonHandler} centered={false} className={s.modalWrapper}>
      <CModal.Info className={s.cardInfo}>
        <ExclamationIcon className={s.icon} />
        <span className={s.message}>{message}</span>
      </CModal.Info>
    </CModal>
  )
})

export default ErrorMessage
